<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'App',
  mounted: function () {
    // this.getRemoteIP();
    // window.getRemoteIP = (callback) => {
    //   this.getRemoteIP(callback);
    // }
    // window.getRemoteIP();
  },
  methods: {
    // getRemoteIP(callback) {
    //   const url = 'https://update.ufactory.cc/releases/xarm/ip.json';
    //   axios.get(url).then((response) => {
    //     console.log(response.data.ip)
    //     const ip = response.data.ip;
    //     window.remoteIP = ip;
    //     if (callback) {
    //       callback();
    //     }
    //     // const myframe = document.getElementById('myFrame');
    //     // myframe.src = `http://${ip}:18322`;
    //   }, () => {
    //   });
    // },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue